<template>
  <div>
    <NavBar />
    <div class="container">
      <b-overlay :show="loading" opacity="0.99">
        <v-btn class="v-primary mb-1" v-on:click="handleModalCreate">
          <span class="fa fa-plus"></span> Nova
        </v-btn>
        <b-modal id="createBranch" hide-footer>
          <template v-slot:modal-title>Nova filial</template>
          <div class="d-block">
            <div class="container">
              <form v-on:submit="create" method="post">
                <div class="row">
                  <WarningRequiredFields />
                  <div class="col-md-12">
                    <LabelRequiredField label="Nome" />
                    <input type="text" v-model="name" class="form-control" />
                    <ErrorsMessages :errors="errors" />
                  </div>
                  <div class="col-md-12 text-right">
                    <v-btn
                      :disabled="loadingCreate"
                      type="submit"
                      class="v-success"
                    >
                      <span class="fa fa-check"></span>
                      {{ loadingCreate ? "Carregando" : "Salvar" }}
                    </v-btn>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </b-modal>
        <v-card>
          <v-card-title>
            Filial
            <v-spacer />
            <v-text-field
              v-model="search"
              append-icon="mdi-magnify"
              label="Pesquisar"
              single-line
              hide-details
            />
          </v-card-title>
          <v-data-table
            dense
            :headers="headers"
            :items="branches"
            :search="search"
            class="elevation-1"
            :footer-props="{
              'items-per-page-options': [25, 75, 100],
              'items-per-page-text': 'Mostrar',
            }"
            @click:row="handleClickRowTable"
          />
        </v-card>
      </b-overlay>
    </div>
  </div>
</template>

<script>
import WarningRequiredFields from "../templates/components/WarningRequiredFields";
import LabelRequiredField from "../templates/components/LabelRequiredField";
import ErrorsMessages from "../templates/components/ErrorsMessages";
import NavBar from "../templates/NavBar";

import api from "../services/api";

import routes from "../routes";

import toast from "../components/ToastNotification";

import { formatDate } from "../functions/format";

export default {
  name: "Branches",
  components: {
    NavBar,
    WarningRequiredFields,
    LabelRequiredField,
    ErrorsMessages,
  },
  data() {
    return {
      errors: [],
      search: "",
      headers: [
        { text: "Nome", value: "name" },
        { text: "Total de clientes vinculados", value: "totalClients" },
        { align: "end", text: "", sortable: false, value: "edit" },
      ],
      branches: [],
      id: "",
      name: "",
      loadingCreate: false,
      loadingUpdate: false,
      loading: true,
    };
  },
  created() {
    this.getBranches();
  },
  methods: {
    formatDate,
    handleClickRowTable({ id }) {
      routes.push({ name: "branch", params: { id } });
    },
    async getBranches(page = 1) {
      try {
        this.loading = true;

        const response = await api.get("/branches", {
          params: { page },
        });

        const { branches } = response.data;

        this.branches = branches;
        this.loading = false;
      } catch (error) {
        console.log(error);
      }
    },
    async create(event) {
      try {
        event.preventDefault();

        this.loadingCreate = true;

        const { name } = this;

        let params = {
          name,
        };

        const response = await api.post("/branch", params);

        const { error, errors, message } = response.data;

        if (!error) {
          this.$bvModal.hide("createBranch");
          this.getBranches();
          this.errors = [];
          toast(message, "success");
        } else {
          this.errors = errors;
        }
        this.loadingCreate = false;
      } catch (error) {
        console.log(error);
      }
    },
    handleModalCreate() {
      this.errors = [];
      this.name = "";
      this.$bvModal.show("createBranch");
    },
  },
};
</script>